import Vue from 'vue'
const SugarDate = require('sugar/date')
const SugarLoc = require('sugar/locales')
import {DefaultLanguage} from '@/locale'

//- Filters
Vue.filter('date', value => {
  if (!value) {
    return ''
  }
  const date = new Date(value)
  return (
    date.getFullYear() +
    '-' +
    (date.getMonth() < 9 ? '0' : '') +
    (date.getMonth() + 1) +
    '-' +
    (date.getDate() < 10 ? '0' : '') +
    date.getDate()
  )
})
Vue.filter('clocktime', value => {
  if (!value) {
    return ''
  }
  const date = new Date(value)
  return SugarDate.Date(date).format('%H:%M')
})
Vue.filter('time', value => {
  if (!value) {
    return ''
  }
  const t = new Date(value)
  t.toLocaleTimeString('sv-SE')
  return (t.getHours() < 10 ? '0' : '') + t.getHours() + '-' + (t.getMinutes() < 10 ? '0' : '') + t.getMinutes()
})
//- Filters
Vue.filter('percent', value => {
  if (!value) {
    return '-'
  }
  const val = Number(value) * 100
  const locale = localStorage.getItem('locale')
  return new Intl.NumberFormat(locale || DefaultLanguage, {maximumSignificantDigits: 3}).format(val)
})
//- Filters
Vue.filter('ago', value => {
  const locale = localStorage.getItem('locale')
  SugarLoc.Date.setLocale(locale || DefaultLanguage)
  return SugarDate.Date(value).relative()
})
//- Filters
Vue.filter('fullName', value => {
  if (!value) {
    return ''
  }
  return value.firstName + ' ' + value.lastName
})
Vue.filter('numApprenticeships', val => {
  if (!val) return '0 lärlingar'
  else if (val < 2) return val + ' lärling'
  return val + ' lärlingar'
})
//- Filters
//To get the mobile format: nnn nnn nn nn
Vue.filter('phoneNo', value => {
  var ret = ''
  var val=''
  var c = 0
  val=value.replace('-', '')
  if (val.length > 2) {
    ret += val.substring(c, c + 3) + ' '
    c += 3
  }
  if (val.substring(0, 1) == '+' && val.length > 5) {
    ret += val.substring(c, c + 3) + ' '
    c += 3
  }
  var i
  for (i = c; i <= val.length; i++) {
    if (i == 3 && val.length >= i) {
      ret += val.substring(i, i + 1)
      i++
    }
    if (val.length > i) {
      ret += val.substring(i, i + 1)
    }
    if (val.length > i + 1) {
      ret += val.substring(i + 1, i + 2) + ' '
      i++
    }
  }
  if (ret.substring(ret.length - 1, ret.length) == ' ') {
    //remove the last space
    ret = ret.substring(0, ret.length - 1)
  }
  return ret
})

Vue.filter('currency', value => {
  return Number(value).toLocaleString('sv-SE');
});

Vue.filter('withCurrencyCode', value => {
  return value ? `${value} kr` : value;
});

Vue.filter('uppercase', function (value) {
  if (!value) return ''
  return value.toString().toUpperCase();
})
Vue.filter('formatPnr', value => {
  if (!value) {
    return ''
  }
  try {
    return value.substr(0, 8) + '-' + value.substr(8, 4)
  } catch {
    return value
  }
})
Vue.filter('formatOrgNo', value => {
  if (!value) {
    return ''
  }
  try {
    return value.substr(0, 6) + '-' + value.substr(6, 4)
  } catch {
    return value
  }
})
Vue.filter('formatZip', value => {
  if (!value || value == 'undefined' || value === null) {
    return ''
  }

  var ret = value
  ret = value.replace(' ', '')

  try {
    return ret.substr(0, 3) + ' ' + ret.substr(3, 2)
  } catch {
    return ret
  }
})
Vue.filter('formatSecretPnr', value => {
  if (!value) {
    return ''
  }
  try {
    return value.substr(0, 8) + '-****'
  } catch {
    return value
  }
})